export const RULES_TAB_URL = "?tab=rules";
export const FAQ_TAB_URL = "?tab=faq";
export const tabs = [ RULES_TAB_URL, FAQ_TAB_URL ];
